import { useContext, useEffect, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import "../styles/Logout.css";
import { IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

function Logout() {
    const { clearUserData, currentLang, setCurrentLang } = useContext(AppContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const translations = {
        'zh-tw': {
            title: '已登出',        
            info: '請重新掃二維碼登入您的停車場'
        },
        'zh-cn': {
            title: '已登出',          
            info: '请重新扫二维码登录您的停车场'
        },
        'en': {
            title: 'Logged out',         
            info: 'Please scan the QR code again to your car park'
        }
    };

    const getTranslation = (key) => translations[currentLang][key] || translations['en'][key];

    const getCurrentLangLabel = () => {
        switch (currentLang) {
            case 'zh-tw':
                return '繁中';
            case 'zh-cn':
                return '简中';
            case 'en':
                return 'Eng';
            default:
                return 'Eng';
        }
    };

    const getOtherLanguages = () => {
        const allLanguages = [
            { code: 'zh-tw', label: '繁中' },
            { code: 'zh-cn', label: '简中' },
            { code: 'en', label: 'Eng' }
        ];
        return allLanguages.filter(lang => lang.code !== currentLang);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLangChange = (langCode) => {
        setCurrentLang(langCode);
        handleClose();
    };

    const renderLangSelector = () => (
        <div style={{ 
            position: 'absolute', 
            top: '50px', 
            fontSize: '36px',
            right: '30px', 
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center'
        }}>
            <IconButton 
                onClick={handleClick}
                style={{
                    color: '#4a4a4aff', // Black globe as in image
                    padding: 0,
                }}
            >
                <LanguageIcon />
            </IconButton>
            <span style={{ marginLeft: '3px', color: '#4a4a4aff', fontSize: '30px' }}>
                {getCurrentLangLabel()}
            </span>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    },
                }}
            >
                {getOtherLanguages().map((lang) => (
                    <MenuItem 
                        key={lang.code} 
                        onClick={() => handleLangChange(lang.code)}
                        style={{
                            fontSize: '14px',
                            color: '#666',
                        }}
                    >
                        {lang.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );

    useEffect(() => {
        // Clear user data immediately
        clearUserData();
    }, [clearUserData]);

    return (
        <div className="logout-page" style={{ position: 'relative' }}>
            {renderLangSelector()}
            <img src="/wilsonparking.jpg" alt="Wilson Parking Logo" className="logout-logo" />
            <div className="logout-container" style={{ paddingTop: '60px' }}>
                <div className="logout-icon">✅</div>
                <h1 className="logout-title">{getTranslation('title')}</h1>
                <p className="logout-message">{getTranslation('info')}</p>
              
            </div>
        </div>
    );
}

export default Logout;